module.exports = __webpack_public_path__ + "static/media/facebook_logo_icon.dc206b4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook_logo_icon.svg
// module id = 66
// module chunks = 0